var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"session__list_table"},[_c('component-table',{attrs:{"labels":[
            {
                key: 'fromDate',
                title: 'Date',
                type: 'date',
                sortable: true
            },
            {
                key: 'rooms',
                title: 'Locations',
                type: 'array',
                subKey: ['venueName', 'name'],
                sortable: true
            },
            {
                key: 'trainers',
                title: 'Trainers',
                type: 'array',
                subKey: 'name',
                sortable: true
            },
            {
                key: 'spaces',
                title: 'Spaces',
                type: 'object',
                subKey: 'available',
                subType: 'number',
                sortable: true
            },
            {
                key: 'status',
                title: 'Status',
                type: 'string',
                sortable: true
            },
            {
                key: 'actions',
                title: '',
                type: '',
                sortable: false
            }
        ],"items":_vm.items,"component-table-item":_vm.SessionListTableItem}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }